export default "__VITE_ASSET__i86g6sqg__"